export const CheckIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4007_7151)">
            <path
                d="M12.3164 2.43555C6.79641 2.43555 2.31641 6.91555 2.31641 12.4355C2.31641 17.9555 6.79641 22.4355 12.3164 22.4355C17.8364 22.4355 22.3164 17.9555 22.3164 12.4355C22.3164 6.91555 17.8364 2.43555 12.3164 2.43555ZM12.3164 20.4355C7.90641 20.4355 4.31641 16.8455 4.31641 12.4355C4.31641 8.02555 7.90641 4.43555 12.3164 4.43555C16.7264 4.43555 20.3164 8.02555 20.3164 12.4355C20.3164 16.8455 16.7264 20.4355 12.3164 20.4355ZM16.1964 8.72555L10.3164 14.6055L8.43641 12.7255C8.04641 12.3355 7.41641 12.3355 7.02641 12.7255C6.63641 13.1155 6.63641 13.7455 7.02641 14.1355L9.61641 16.7255C10.0064 17.1155 10.6364 17.1155 11.0264 16.7255L17.6164 10.1355C18.0064 9.74555 18.0064 9.11555 17.6164 8.72555C17.2264 8.33555 16.5864 8.33555 16.1964 8.72555Z"
                fill="#E30018"
            />
        </g>
        <defs>
            <clipPath id="clip0_4007_7151">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.316406 0.435547)"
                />
            </clipPath>
        </defs>
    </svg>
);